import { Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ListItem } from '../../../../shared'
import { DailyReport, InspectionItem } from '../daily-report.model'

@Component({
    selector: 'app-daily-report-form',
    templateUrl: './daily-report-form.component.html',
    styleUrls: ['./daily-report-form.component.css'],
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class DailyReportFormComponent {
    dailyReport = input.required<DailyReport>()
    jobOptions = input<ListItem<string>[]>([])
    employeeOptions = input<ListItem<number>[]>([])
    equipmentOptions = input<ListItem<string>[]>([])

    statusOptions: ListItem<string>[] = [
        new ListItem('', 'OK'),
        new ListItem('Minor', 'Minor'),
        new ListItem('Critical', 'Critical'),
    ]

    equipmentStatusOptions: ListItem<string>[] = [
        new ListItem('', 'Select...'),
        new ListItem('OK', 'OK'),
        new ListItem('Needs Repair', 'Needs Repair'),
        new ListItem('Down/Needs Repair', 'Down/Needs Repair'),
    ]

    hasCritical(items: InspectionItem[]): boolean {
        return items.some(i => i.status === 'Critical')
    }

    hasMinor(items: InspectionItem[]): boolean {
        return !this.hasCritical(items) && items.some(i => i.status === 'Minor')
    }
}
